// Mutations will be refactored into modules at a later time

import initialState from './state'

export const setPerPage = function (state, perPage) {
  state.perPage = perPage
}

export const setCurrentUser = function (state, user) {
  state.currentUser = user
}

export const setStatuses = function (state, statuses) {
  state.statuses = statuses
}

export const setCurrentCompany = function (state, companyId) {
  state.currentCompany = companyId
}

export const setWorkOrderStatus = function (state, workOrderStatus) {
  state.workOrderStatus = workOrderStatus
}

export const setPicklistStatus = function (state, picklistStatus) {
  state.picklistStatus = picklistStatus
}

export const setPicklistUnits = function (state, picklistUnits) {
  state.picklistUnits = picklistUnits
}

export const setWorkOrderUnit = function (state, workOrderUnit) {
  state.workOrderUnit = workOrderUnit
}

export const setWorkOrderResponsible = function (state, workOrderResponsible) {
  state.workOrderResponsible = workOrderResponsible
}

export const setResponsibleSeller = function (state, responsibleSeller) {
  state.responsibleSeller = responsibleSeller
}

export const setSelectedFlataRows = function (state, flataRows) {
  state.selectedFlataRows = flataRows
}

export const updateSelectedFlataRows = function (state, params) {
  var idx = state.selectedFlataRows.map(object => object.id).indexOf(params.id)
  state.selectedFlataRows[idx][params.field] = params.value
}

export const setSelectedFlata = function (state, flata) {
  state.selectedFlata = flata
}

export const removeSelectedFlataRows = function (state, id) {
  state.selectedFlataRows = state.selectedFlataRows.filter(function (x) {
    if (x.id !== id) {
      return x
    }
  })
}

export const removeSelectedFlata = function (state, id) {
  state.selectedFlata = state.selectedFlata.filter(function (x) {
    if (x !== id) {
      return x
    }
  })
}

export const setCurrentReport = function (state, data) {
  data.comment = ''
  if (state.currentCompany in state.currentReports) {
    if (!state.currentReports[state.currentCompany].find(o => o.joint_id === data.joint_id)) {
      var newArr = state.currentReports[state.currentCompany]
      newArr.push(data)
      state.currentReports = Object.assign({}, state.currentReports, {
        [state.currentCompany]: newArr
      })
      setSelectedReportRows(state, data.joint_id)
    }
  } else {
    state.currentReports = Object.assign({}, state.currentReports, {
      [state.currentCompany]: data
    })
    setSelectedReportRows(state, data.joint_id)
  }
}

export const setCurrentReportComment = function (state, data) {
  state.currentReports[state.currentCompany][data.idx].comment = data.comment
}

export const setCurrentReportOperatorId = function (state, data) {
  state.currentReports[state.currentCompany][data.idx].oper_id = data.oper_id
}

export const setCurrentReportDateTime = function (state, data) {
  state.currentReports[state.currentCompany][data.idx].datetime = data.datetime
}

export const setCurrentReportName = function (state, data) {
  state.currentReportName = data
}

export const setCurrentReportsDefaults = function (state, companies) {
  companies.forEach(function (c) {
    state.currentReports = Object.assign({}, state.currentReports, {
      [c.id]: []
    })
  })
}

export const clearCurrentReport = function (state) {
  state.currentReports = Object.assign({}, state.currentReports, {
    [state.currentCompany]: []
  })
  state.currentReportName = ''
  clearSelectedReportRows(state)
}

export const removeCurrentReportEntry = function (state, jointId) {
  state.currentReports = Object.assign({}, state.currentReports, {
    [state.currentCompany]: state.currentReports[state.currentCompany].filter(function (x) {
      if (x.joint_id !== jointId) {
        return x
      }
    })
  })
}

export const setSelectedReportRows = function (state, jointId) {
  state.selectedReportRows[state.currentCompany].push(jointId)
}

export const clearSelectedReportRows = function (state) {
  state.selectedReportRows[state.currentCompany] = []
}

export const setSelectedReportRowsDefaults = function (state, companies) {
  companies.forEach(function (c) {
    state.selectedReportRows = Object.assign({}, state.selectedReportRows, {
      [c.id]: []
    })
  })
}

export const setRouteDataDefaults = function (state, routes) {
  routes.forEach(function (c) {
    state.routeData = Object.assign({}, state.routeData, {
      [c.name]: {
        filters: {
          date: [],
          equipment_type: [],
          current_rentals: null,
          search: '',
          id_interval: [],
          status: null,
          show_hidden_equipment: null
        }
      }
    })

    if (typeof c.children !== 'undefined') {
      c.children.forEach(function (b) {
        state.routeData = Object.assign({}, state.routeData, {
          [b.name]: {
            filters: {
              date: [],
              equipment_type: [],
              current_rentals: null,
              search: '',
              id_interval: [],
              status: null,
              show_hidden_equipment: null
            }
          }
        })
      })
    }
  })
}

export const setRouteFilterData = function (state, params) {
  state.routeData[params.routeName]['filters'] = Object.assign({}, state.routeData[params.routeName]['filters'], {
    [params.filterType]: params.value
  })
}

export const removeSelectedReportRowsEntry = function (state, jointId) {
  state.selectedReportRows[state.currentCompany] = state.selectedReportRows[state.currentCompany].filter(function (x) {
    if (x !== jointId) {
      return x
    }
  })
}

export const resetState = function (s) {
  const initial = initialState
  Object.keys(initial).forEach(key => { s[key] = initial[key] })
  s.currentReports = {}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js